import { Directive, HostListener } from "@angular/core";

@Directive({
    selector: "[appNumbersOnly]",
    standalone: false
})
export class NumbersOnlyDirective {
  @HostListener("input", ["$event"]) onInput(event: any) {
    const input = event.target;
    const value = input.value;

    // Remove non-numeric characters
    const numbersOnly = value.replace(/[^\d/]/g, "");

    // Update the input value with only the numbers
    input.value = numbersOnly;
  }
}
